import { Autocomplete, Popper, TextField } from "@mui/material";
import { GridColDef, GridRowId } from "@mui/x-data-grid";
import { FornecedorDropDown } from "../../../../../../common/domain/models/fornecedor_dropdown";
import { MoneyMaskedInput } from "../../../../../../common/components/masked_inputs/money_masked_input";
import { MoneyMaskedInput2 } from "../../../../../../common/components/masked_inputs/money_masked_input2";

type Props = {
  OnActionValorChange(valor: string | null, idLinhaGrid: GridRowId): void;
  OnActionCentroCustoChange(
    idCentroCusto: number | null,
    idLinhaGrid: GridRowId,
  ): void;
  OnActionQuantidadeChange(
    quantidade: number | null,
    idLinhaGrid: GridRowId,
  ): void;
  OnActionFornecedorChange(
    idFornecedor: number | null,
    idLinhaGrid: GridRowId,
  ): void;

  centroCustoLista: any[];
  fornecedorLista: FornecedorDropDown[];
};

export const GenerateEntradaProdutosMultiColumns = ({
  OnActionValorChange,
  OnActionCentroCustoChange,
  OnActionQuantidadeChange,
  OnActionFornecedorChange,
  centroCustoLista,
  fornecedorLista,
}: Props): GridColDef[] => {
  return [
    {
      field: "NomeProdutoServico",
      filterable: false,
      headerName: "Produto",
      flex: 1.5,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Unidade",
      filterable: false,
      headerName: "Unidade",
      minWidth: 90,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "IdCentroCusto",
      filterable: false,
      minWidth: 280,
      flex: 2,
      headerName: "Centro de Custo",
      sortable: false,
      renderCell: (params) => {
        const { row, id } = params;
        const valorSelecionado = row.IdCentroCusto
          ? centroCustoLista.find((c) => c.id === row.IdCentroCusto) || null
          : null;

        return (
          <div className="w-full flex items-center justify-center h-full p-1">
            <Autocomplete
              size="small"
              fullWidth
              // Removido o disablePortal para o menu flutuar livremente sobre a Grid
              PopperComponent={(props) => (
                <Popper {...props} style={{ width: 'auto', minWidth: props.style?.width }} placement="bottom-start" />
              )}
              options={centroCustoLista}
              getOptionLabel={(option) => option.title || ""}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              value={valorSelecionado}
              onChange={(_, newValue) => {
                OnActionCentroCustoChange(newValue?.id ?? null, id);
              }}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  {option.title}
                </li>
              )}
              renderInput={(paramsInput) => (
                <TextField
                  {...paramsInput}
                  variant="outlined"
                  placeholder="Selecione..."
                  size="small"
                />
              )}
            />
          </div>
        );
      },
    },
    {
      field: "IdFornecedor",
      filterable: false,
      minWidth: 280,
      flex: 2,
      headerName: "Fornecedor",
      sortable: false,
      renderCell: (params) => {
        const { row, id } = params;
        const valorSelecionado = row.IdFornecedor
          ? fornecedorLista.find((f) => f.idFornecedor === row.IdFornecedor) ||
          null
          : null;

        return (
          <div className="w-full flex items-center justify-center h-full p-1">
            <Autocomplete
              size="small"
              fullWidth
              // Removido o disablePortal para o menu flutuar livremente sobre a Grid
              PopperComponent={(props) => (
                <Popper {...props} style={{ width: 'auto', minWidth: props.style?.width }} placement="bottom-start" />
              )}
              options={fornecedorLista}
              getOptionLabel={(option) => String(option.nomeFantasia) || ""}
              isOptionEqualToValue={(option, value) =>
                option.idFornecedor === value.idFornecedor
              }
              value={valorSelecionado}
              onChange={(_, newValue) => {
                OnActionFornecedorChange(newValue?.idFornecedor ?? null, id);
              }}
              renderOption={(props, option) => (
                <li {...props} key={option.idFornecedor}>
                  {option.nomeFantasia}
                </li>
              )}
              renderInput={(paramsInput) => (
                <TextField
                  {...paramsInput}
                  variant="outlined"
                  placeholder="Selecione..."
                  size="small"
                />
              )}
            />
          </div>
        );
      },
    },
    {
      field: "Quantidade",
      filterable: false,
      minWidth: 120,
      flex: 0.8,
      headerName: "Quantidade",
      sortable: false,
      renderCell: (params) => {
        const { row, id } = params;
        return (
          <div className="w-full flex items-center justify-center h-full p-1">
            <TextField
              size="small"
              fullWidth
              type="number"
              variant="outlined"
              value={row.Quantidade ?? ""}
              onChange={(e) => {
                const valor = e.target.value ? Number(e.target.value) : null;
                OnActionQuantidadeChange(valor, id);
              }}
            />
          </div>
        );
      },
    },
    {
      field: "ValorUnitario",
      filterable: false,
      minWidth: 160,
      flex: 1,
      headerAlign: "center",
      headerName: "Valor Unitário",
      sortable: false,
      renderCell: (params) => {
        const { row, id } = params;

        const value =
          row.ValorUnitario !== null && row.ValorUnitario !== undefined
            ? String(row.ValorUnitario)
            : "";

        return (
          <div className="w-full flex items-center justify-center h-full p-1">
            <MoneyMaskedInput2
              name="ValorUnitario"
              label=""
              readOnly={false}
              value={value}
              onChange={(novoValor) => {
                OnActionValorChange(novoValor, id);
              }}
            />
          </div>
        );
      },
    },
  ];
};